import { Link } from "react-router-dom";

// Polished brand mark: circular crop of the canonical donkey head (never regenerated).
export function DonkeyFaceMark({ size = 40, className = "" }) {
  return (
    <span
      style={{ width: size, height: size }}
      className={`relative inline-flex shrink-0 rounded-full overflow-hidden bg-[#111111] ring-1 ring-donkey-orange/45 ${className}`}
      aria-hidden="true"
    >
      <img
        src="/donkey-hero.png"
        alt=""
        className="absolute max-w-none pointer-events-none select-none"
        style={{ width: size * 3, height: "auto", left: -size * 1.38, top: -size * 1.42 }}
      />
    </span>
  );
}

// Retained minimal vector mark for compact/monochrome contexts.
export function DonkeyMark({ size = 40, className = "" }) {
  return <DonkeyFaceMark size={size} className={className} />;
}

export function Logo({ to = "/", showText = true, className = "" }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2.5 group ${className}`}
      data-testid="logo-link"
    >
      <DonkeyFaceMark size={40} className="transition-transform group-hover:scale-105" />
      {showText && (
        <span className="font-heading font-bold tracking-tight text-donkey-warm leading-none text-base sm:text-lg flex items-center gap-1.5 whitespace-nowrap">
          The Honest Donkey
          <span className="w-1.5 h-1.5 rounded-full bg-donkey-orange" />
        </span>
      )}
    </Link>
  );
}

export default Logo;
